import { useAuth } from '../pages/login/OAuth';

const useDocumentService = () => {
    const { api } = useAuth();

    const getDocuments = (params) =>
        api().get('/documents/', { params });

    const getDocumentBlob = (id) =>
        api().get(`/documents/${id}`, { responseType: 'blob' });

    const addDocument = (formData) =>
        api().post('/documents/add', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });

    const disableDocument = (id) =>
        api().patch('/documents/disable', { document_id: id });

    const disableDocumentByObjectId = (formData) =>
        api().patch('/documents/disable_by_object_id', formData);

    return {
        getDocuments,
        getDocumentBlob,
        addDocument,
        disableDocument,
        disableDocumentByObjectId,
    };
};

export default useDocumentService;
